import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "text-gray-400" }
const _hoisted_2 = { class: "truncate font-medium text-gray-900" }
const _hoisted_3 = {
  key: 0,
  class: "truncate text-xs"
}
const _hoisted_4 = { class: "text-right font-medium text-gray-900" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }

import { computed, ref } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import ReportDelta from '@/components/reports/ReportDelta.vue'
import { formatDollars } from '@/helpers/money'
import { fractionChange } from '@/services/franchiseSales.service'

const TOP = 5

export default {
  __name: 'FranchiseLeaderboard',
  props: {
  rows: { type: Array, default: () => [] }
},
  emits: ['select'],
  setup(__props, { emit: __emit }) {

const COLUMNS = ['2rem', '3fr', '1fr', '1fr', '1fr', '1fr']

const props = __props
const emit = __emit

const showAll = ref(false)
const visibleRows = computed(() => (showAll.value ? props.rows : props.rows.slice(0, TOP)))

const dollars = cents => formatDollars((Number(cents) || 0) / 100)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(NeueTablist, {
    name: "Locations",
    description: "Net sales by location for this period"
  }, {
    aside: _withCtx(() => [
      (__props.rows.length > TOP)
        ? (_openBlock(), _createBlock(NeueButton, {
            key: 0,
            type: "secondary",
            "data-test": "leaderboard-toggle",
            onClick: _cache[0] || (_cache[0] = $event => (showAll.value = !showAll.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(showAll.value ? `Show top ${TOP}` : `Show all ${__props.rows.length} locations`), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    head: _withCtx(() => [
      _createVNode(TablistHeader, null, {
        default: _withCtx(() => [
          _createVNode(TablistGrid, {
            columns: COLUMNS,
            header: ""
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", null, "#", -1),
              _createElementVNode("div", null, "Location", -1),
              _createElementVNode("div", { class: "text-right" }, "Net sales", -1),
              _createElementVNode("div", { class: "text-right" }, "Orders", -1),
              _createElementVNode("div", { class: "text-right" }, "Avg order", -1),
              _createElementVNode("div", { class: "text-right" }, "vs previous", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRows.value, (row, index) => {
        return (_openBlock(), _createBlock(TablistRow, {
          key: row.merchant_id,
          "data-test": "leaderboard-row",
          class: "cursor-pointer",
          role: "button",
          tabindex: "0",
          onKeydown: [
            _withKeys(_withModifiers($event => (emit('select', String(row.merchant_id))), ["prevent"]), ["enter"]),
            _withKeys(_withModifiers($event => (emit('select', String(row.merchant_id))), ["prevent"]), ["space"])
          ],
          onClick: $event => (emit('select', String(row.merchant_id)))
        }, {
          default: _withCtx(() => [
            _createVNode(TablistGrid, {
              columns: COLUMNS,
              class: "items-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(index + 1), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(row.name), 1),
                  (row.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(row.location), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(dollars(row.net_cents)), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(row.orders), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(dollars(row.aov_cents)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(ReportDelta, {
                    delta: _unref(fractionChange)(Number(row.net_cents) || 0, Number(row.previous_net_cents) || 0)
                  }, null, 8, ["delta"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["onKeydown", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

}